import { render } from "./EditDeleteControls.vue?vue&type=template&id=fc1590f0"
import script from "./EditDeleteControls.vue?vue&type=script&lang=js"
export * from "./EditDeleteControls.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_0358080b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__